import type { OperationalActionDescriptor } from '../executionActionsFacade';
import { buildCompletionDashboardProjection } from '../../../operationalDomain/completion/completionReadiness';
import type { CompletionReadinessProjection } from './types';

export type CompletionReadinessContext = {
  manualPenaltyCount?: number;
  recordedPenaltyCount?: number;
  unconfirmedExpenseCount?: number;
  hasLogistCommentOnRoute?: boolean;
  lifecyclePhaseReady?: boolean;
  forceHideHints?: boolean;
  executionBlockers?: string[];
};

export function buildCompletionReadinessProjection(params: {
  actions: OperationalActionDescriptor[];
  context?: CompletionReadinessContext;
}): CompletionReadinessProjection {
  const ctx = params.context ?? {};
  const showHints =
    !ctx.forceHideHints &&
    (Boolean(ctx.lifecyclePhaseReady) ||
      params.actions.some((a) => a.key === 'complete_route' && !a.disabled));

  const domain = buildCompletionDashboardProjection({
    showCompletionHints: showHints,
    manualPenaltyCount: ctx.manualPenaltyCount ?? 0,
    recordedPenaltyCount: ctx.recordedPenaltyCount ?? 0,
    unconfirmedExpenseCount: ctx.unconfirmedExpenseCount ?? 0,
    hasLogistCommentOnRoute: ctx.hasLogistCommentOnRoute ?? false,
    executionBlockers: ctx.executionBlockers
  });

  return {
    showHints: domain.showHints,
    canComplete: domain.readiness.canComplete,
    readinessState: domain.readiness.readinessState,
    warnings: domain.readiness.warnings,
    pendingManualPenaltyCount: domain.pendingManualPenaltyCount,
    recordedPenaltyCount: domain.recordedPenaltyCount,
    unconfirmedExpenseCount: domain.unconfirmedExpenseCount
  };
}
